import { createStore } from 'vuex'

const ACTIVE_PAGE_UUID_KEY = "activePageUUID";

function normalizeActivePageUUID(activePageUUID) {
  if (typeof activePageUUID !== "string") return null;

  const value = activePageUUID.trim();
  if (!value || value === "null" || value === "undefined") return null;
  return value;
}

function getBrowserLocalStorage() {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch (error) {
    return null;
  }
}

function getStoredActivePageUUID() {
  const storage = getBrowserLocalStorage();
  if (!storage) return null;

  try {
    return normalizeActivePageUUID(storage.getItem(ACTIVE_PAGE_UUID_KEY));
  } catch (error) {
    return null;
  }
}

function persistActivePageUUID(activePageUUID) {
  const storage = getBrowserLocalStorage();
  if (!storage) return;

  try {
    if (activePageUUID) {
      storage.setItem(ACTIVE_PAGE_UUID_KEY, activePageUUID);
    } else {
      storage.removeItem(ACTIVE_PAGE_UUID_KEY);
    }
  } catch (error) {
    // 浏览器禁用存储时保留内存状态，不阻断应用启动和登录流程
  }
}

export default createStore({
  state: {
    userInfo: null,       //用户信息
    companyInfo: null,    //公司信息
    shopInfo: null,       //门店信息
    sysParam: [],         //系统参数
    powerList: [],        //权限集合
    menuList: [],         //菜单集合
    tabList: [],          //tab集合
    currRouter: {},       //当前路由页
    activePageUUID: getStoredActivePageUUID(), //页面uuid
    rolePower:null,       //分配角色权限ID
    comParam:null,        //公共传递的参数, name:传递key, value:传递数据
    routerParam:{},       //路由传递参数, key:路由名称,value:传递数据(sourRouter:返回时候返回的路由)
    homePage:'房间',      //首页类型
    isModuleVisible: false,// 控制旧的报表下载按钮是否显示，冗余操作
  },
  getters:{
    //获取当前路由参数
    getRouterParam(state){
      return state.routerParam[state.currRouter.name]
    },
    //获取tab页
    getKeepAliveList(state){
      let list = [];
      for (let i = 0; i < state.tabList.length; i++) {
        list.push(state.tabList[i].name)
      }
      return list
    },
    //获取指定系统参数
    getSysParamList(state, getters){
      return logicName => {
        let list = [];
        for (let i = 0; i < state.sysParam.length; i++) {
          if(state.sysParam[i].logicName == logicName){
            list = state.sysParam[i].sysParamValueList;
          }
        }
        return list
      }
    },
  },
  mutations: {
    routerParam (state, param) {
      state.routerParam[param.key] = param.value
    },
    setHomepage (state, homePage) {
      state.homePage = homePage
    },
    setComParam (state, comParam) {
      state.comParam = comParam
    },
    setActivePageUUID (state, activePageUUID) {
      const value = normalizeActivePageUUID(activePageUUID);
      state.activePageUUID = value;
      persistActivePageUUID(value);
    },
    setRolePower (state, rolePower) {
      state.rolePower = rolePower
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setCompanyInfo (state, companyInfo) {
      state.companyInfo = companyInfo
    },
    setShopInfo (state, shopInfo) {
      state.shopInfo = shopInfo
    },
    setSysParam (state, sysParam) {
      state.sysParam = sysParam
    },
    setMenuList (state, menuList) {
      state.menuList = menuList
    },
    setPowerList (state, powerList) {
      state.powerList = powerList
    },
    setTabList (state, tabList) {
      state.tabList = tabList
    },
    setCurrRouter (state, currRouter) {
      state.currRouter = currRouter
    },
  },
  actions: {
    // setToken ({ commit },token) {
    //   commit("setToken",token);
    // },
    // setUserInfo ({ commit },userInfo) {
    //   commit("setUserInfo",userInfo);
    // },
  },
  modules: {
  }
})
